import React from "react";
import Glimmer from "@components/Glimmer";

const style = {marginTop: 5, marginBottom: 5} as const;
const TimeInfoLoading = () => {
  return <Glimmer height={20} width={200} style={style} />;
};

export default React.memo(TimeInfoLoading);
